import { lazy } from "react";

export { JMIX_REPORTS_PAGE_SECURITY_TOKENS } from "./jmix-reports-page-security-tokens";
export { JMIX_REPORTS_PATH } from "./jmix-reports-path";
export const JmixReportsPage = lazy(() => import("./jmix-reports-page"));
